



































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PageNames from '@/router/PageNames';
import EntityIdentifier from '@/models/Shared/EntityIdentifier';
import EntityType from '@/models/Shared/EntityType';
import { PersonModule } from '@/store/Customers/PersonModule';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';

@Component({ name: 'RelatedRecords' })
export default class extends SaascadaVue {

    @Prop({required: true})
    entityType: EntityType;

    headers = [
        { text: this.$t('pageText.customers.fields.name') },
        { text: this.$t('pageText.customers.fields.entityType') },
        { text: this.$t('pageText.customers.fields.relationshipType') },
        { text: this.$t('pageText.customers.fields.ownership') },
        { text: this.$t('pageText.customers.fields.metadata') }
    ];
    relatedRecordsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.relatedRecordsPage = +page;
        }
    }

    async beforeMount() {
        if (this.entityType === EntityType.Person) {
            await PersonModule.getRelatedRecords(this.relatedRecordsPage);
        } else {
            await OrganisationModule.getRelatedRecords(this.relatedRecordsPage);
        }
    }

    @Watch('relatedRecordsPage')
    async onRelatedRecordsPage() {
        // Update route with tab and page number (if it has changed)
        if (this.relatedRecordsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.relatedRecordsPage}` } });
        }
        // Get related records
        if (this.entityType === EntityType.Person) {
            await PersonModule.getRelatedRecords(this.relatedRecordsPage);
        } else {
            await OrganisationModule.getRelatedRecords(this.relatedRecordsPage);
        }
    }

    get relatedRecords() {
        if (this.entityType === EntityType.Person) {
            return PersonModule.relatedRecords;
        } else {
            return OrganisationModule.relatedRecords;
        }
    }

    get loading() {
        if (this.entityType === EntityType.Person) {
            return PersonModule.loadingRelatedRecords;
        } else {
            return OrganisationModule.loadingRelatedRecords;
        }
    }

    get totalRelatedRecordsPages() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.totalRelatedRecordsPages;
        }
        else {
            return PersonModule.totalRelatedRecordsPages;
        }
    }

    get pageSize() {
        if (this.entityType === EntityType.Organisation) {
            return OrganisationModule.pageSize;
        }
        else {
            return PersonModule.pageSize;
        }
    }

    async navigateToEntity(entityIdentifier: EntityIdentifier) {
        if (entityIdentifier.entityType === this.EntityType.Person) {
            this.$router.push({ name: PageNames.Person, params: { id: entityIdentifier.entityId } });
        } else {
            this.$router.push({ name: PageNames.Organisation, params: { id: entityIdentifier.entityId } });
        }
    }

}
